import { Injectable } from "@angular/core"

@Injectable()
export class CplErrorMessageHelpersService {
    generateErrorMap = () => {
        return {
            minlength: this.minlength,
            equalLength: this.equalLength,
            isGreaterThanZero: this.isGreaterThanZero,
            isGreaterThanZeroOrNotSet: this.isGreaterThanZeroOrNotSet,
            isAlphaNumeric: this.isAlphaNumeric,
            entriesCount: this.entriesCount,
            operationRequired: this.operationRequired,
            equal: this.equal
        }
    }

    /* IMPORTANT: Each of the function names maps to the error name */ 

    minlength({ actualLength, requiredLength } : { actualLength: number, requiredLength: number }) {
        return `Must be greater than ${requiredLength} characters long. Currently ${actualLength} characters long.`
    }

    equalLength({ actualLength, requiredLength } : { actualLength: number, requiredLength: number }) {
        return `Must be exactly ${requiredLength} character(s) long. Currently ${actualLength} character(s) long.`
    }

    isGreaterThanZero() {
        return 'Must be greater than zero.';
    }

    isGreaterThanZeroOrNotSet() {
        return 'Must be greater than zero.';
    }

    isAlphaNumeric() {
        return 'All characters must be numbers or letters.';
    }

    entriesCount({ actualLength: length, min, max}: { actualLength: number, min?: number, max?: number }) {
        if (min == undefined && max == undefined) {
            return `Issue with the number of items. Currently ${length} items.`
        }

        if (min == undefined) {
            return `Must be less than ${max} items. Currently ${length} items.`
        }

        if (max == undefined) {
            return `Must be greater than ${min} items. Currently ${length} items.`
        }

        return `Must be between ${min} and ${max} items. Currently ${length} items.`

    }

    operationRequired() {
        return 'Operation is required.';
    }

    equal() {
        return 'Passwords must match.';
    }
}